import { Directive, ElementRef, OnInit, Optional } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { SecurityService } from '../../service';

@Directive({
  selector: '[appVisualizaPreenchimento]'
})
export class VisualizaPreenchimentoDirective implements OnInit {

  private initialStatusDisplay: string;

  constructor(
    private readonly element: ElementRef,
    private readonly securityService: SecurityService,
    @Optional() private readonly controlContainer: FormGroupDirective) {
  }

  ngOnInit(): void {
    this.initializeDefaultState();
  }

  private initializeDefaultState() {
    this.initialStatusDisplay = this.element.nativeElement.style.display;
    this.element.nativeElement.style.display = 'none';
    this.evaluatePermissionDisplayElement();
  }

  private evaluatePermissionDisplayElement() {
    this.securityService.obterRdaAutenticado().subscribe(rda => {
      if (rda && rda.composicaoRda.id !== rda.composicaoRdaResponsavelPreenchimento.id) {
        this.element.nativeElement.style.display = this.initialStatusDisplay;
      }
    });
  }

}
